<template>
  <div class="request-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div>

          <v-row class="relative">
            <v-col cols="8">
              <v-text-field
                :label="$t('phoneNoNotReq')"
                v-model="other_number"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <div class="choose-select">
                <v-select
                  :items="phone_code_items"
                  :label="$t('select')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_phone_code"
                >
                </v-select>
              </div>
            </v-col>

          </v-row>
<hr>
          <v-row class="relative">
            <v-col cols="6">
              <label
              >{{$t('deviceStatus')}}</label>
            </v-col>
            <v-col cols="6">
              <div class="choose-select">
                <v-select
                  :items="device_status_items"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_device_status"
                >
                </v-select>
              </div>
            </v-col>
          </v-row>
<hr>
          <div>
            <v-switch v-if="enable_send_from_country"
                      v-model="send_from_country"
                      :label="$t('sendFromOtherCity')"
            ></v-switch>
          </div>

          <v-row v-if="send_from_country">

            <v-col>
              <v-select
                :items="province_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_province"
              >
              </v-select>
            </v-col>

            <v-col>
              <v-select
                :items="city_items"
                single-line
                item-text="label"
                item-value="value"
                v-model="selected_city"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :label="$t('expertDesc')"
                v-model="technician_summary"
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                :label="$t('appearenceProblem')"
                v-model="device_appearence"
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                :label="$t('customerDesc')"
                v-model="customer_summary"
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>

        </div>
        <div>
          <v-row>

            <v-btn color="primary enter-btn" v-on:click="go_to_categories()">
              {{$t('sendInformation')}}
            </v-btn>

          </v-row>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        request_details: '',
        errors: [],
        phone_code_items: [],
        selected_phone_code: 1,
        other_number: '',

        device_status_items: [],
        selected_device_status: 0,
        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        send_from_country: false,

        technician_summary: '',
        device_appearence: '',
        enable_send_from_country: false,
        customer_summary: '',
        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      // console.log("response", passing_data.ServiceOutBranchOnFinalize);

      this.enable_send_from_country = !passing_data.on_site_service
      if (passing_data.customer_summary != null) {
        this.customer_summary = passing_data.customer_summary
      }

      if (passing_data.other_phone_code != null) {
        this.selected_phone_code = passing_data.other_phone_code
      }
      if (passing_data.other_phone_no != null) {
        this.other_number = passing_data.other_phone_no
      }
      this.get_phone_prefix()
      this.get_device_status()
      this.get_provinces()
    },
    methods: {
      login () {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddRequestReceipt', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg + '\n' + self.$t('requestCodeQ') + response.data.ReqCode])
              self.$router.push({ name: 'attachment', params: { rec_id: response.data.ReqId } })
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      preRequestToRequest () {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PreRequestToRequest', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              var request_data = JSON.parse(localStorage.getItem('request_data'))

              if (request_data.ServiceOutBranchOnFinalize != null && request_data.ServiceOutBranchOnFinalize != '0') {
                self.submit_service_out_branch(response.data.ReqId, request_data.ServiceOutBranchOnFinalize, response)
              } else {
                bus.$emit('show_dialog', [self.$t('requestSubmitted'), response.data.msg + '\n' + self.$t('requestCodeQ') + response.data.ReqCode])

                self.$router.push({ name: 'attachment', params: { rec_id: response.data.ReqId } })
              }
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      submit_service_out_branch (rec_id, status, res) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: rec_id,
          Desc: '',
          StatusId: status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangeRequestRefer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              bus.$emit('show_dialog', [self.$t('requestSubmitted'), res.data.msg + '\n' + self.$t('requestCodeQ') + res.data.ReqCode])

              self.$router.push({ name: 'attachment', params: { rec_id: response.data.ReqId } })
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_bind_data () {
        var request_id = 0

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.PreRequestId != null) {
          request_id = request_data.PreRequestId
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var pre_defined_array = []
        var pre_defined = JSON.parse(request_data.pre_defined)

        pre_defined.forEach(function (number) {
          if (number.PredefineTypeId == 1 && number.IsChecked) {
            var pre_obj = {
              TextId: number.TextId,
              Text: '',
              PreDefineTypeId: number.PredefineTypeId,
              CurrencyId: 0
            }
            pre_defined_array.push(pre_obj)
          }
          if (number.PredefineTypeId == 2 && number.Value != null) {
            var pre_obj = {
              TextId: number.TextId,
              Text: number.Value,
              PreDefineTypeId: number.PredefineTypeId,
              CurrencyId: 0
            }
            pre_defined_array.push(pre_obj)
          }
        })

        const send_data = {

          CheckBoxes: pre_defined_array,

          RequestName: request_data.request_name + ' ' + request_data.device_model,

          BranchId: request_data.branch_id,
          ExpertId: user_id, //
          DevicePassword: request_data.device_password, //
          CustomerPhone: request_data.customer_mobile, //
          DevicePattern: '', //
          CustomerName: request_data.customer_name, //
          ExpertOpinion: this.technician_summary, //
          AppearanceProblem: this.device_appearence, //
          RequestDescription: this.customer_summary, //
          ModelId: request_data.device_model_id, //
          ModelTitle: request_data.device_model, //
          CityId: 0, //
          ServiceOutBranch: this.send_from_country, //
          PhoneCode: this.selected_phone_code, //
          PhoneNo: this.other_number, //
          CurrentStatus: this.selected_device_status, //
          Id: 0, //
          PreRequestId: request_id, //
          ProductTypeId: request_data.cat_id, //
          CategoryId: request_data.group_id, //
          GroupId: request_data.sub_group_id, //
          SubGroupId: request_data.brand_id, //
          CurrencyId: request_data.currency,
          PriceRange: request_data.price,
          OnSiteService: request_data.on_site_service,
          DeliveryDay: request_data.tamir_days,
          DeliveryDate: '',

        }
        if (this.send_from_country) {
          send_data.CityId = this.selected_city
        }
        return send_data
      },
      go_to_categories () {
        if (this.technician_summary == '' || this.device_appearence == '' || this.customer_summary == '') {
          bus.$emit('show_toast', [1500, this.$t('fillAllFields')])

          return false
        }
        if (this.selected_device_status == 0) {
          bus.$emit('show_toast', [1500, this.$t('selectDeviceStatus')])

          return false
        }

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.stateId == null) {
          this.login()
        } else if (request_data.stateId == 'final_pre_request') {
          this.preRequestToRequest()
        }
      },
      get_phone_prefix () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPhonePrefixList', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              var obj = { value: number.Id, label: number.Code }
              self.phone_code_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqCurrentStatus', send_data, {})
          .then(response => {
            var obj = { value: 0, label: self.$t('select') }
            self.device_status_items.push(obj)
            response.data.forEach(function (number) {
              var obj = { value: number.RecId, label: number.RecTitle }
              self.device_status_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_provinces () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProvincies', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              if (number.ProvinceName == 'تهران') {
                self.selected_province = number.ProvinceId
              }
              var obj = { value: number.ProvinceId, label: number.ProvinceName }
              self.province_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_cities () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          PId: this.selected_province,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCitiesByProvinceId', send_data, {})
          .then(response => {
            self.city_items = []
            self.selected_city = response.data.cities[0].CityId
            response.data.cities.forEach(function (number) {
              if (number.CityName == self.$t('selectedAddressCityCurrent')) {
                self.selected_city = number.CityId
              }
              var obj = { value: number.CityId, label: number.CityName }
              self.city_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
